import Vue from 'vue'

// List of available icons
// https://carbondesignsystem.com/guidelines/icons/library/

import { CarbonIconsVue } from '@carbon/icons-vue'
import Add from '@carbon/icons-vue/lib/add/32'
import ArrowLeft from '@carbon/icons-vue/lib/arrow--left/32'
import ArrowRight from '@carbon/icons-vue/lib/arrow--right/32'
import Bookmark from '@carbon/icons-vue/lib/bookmark/32'
import Chat from '@carbon/icons-vue/lib/chat/32'
import Checkbox from '@carbon/icons-vue/lib/checkbox/32'
import CheckboxChecked from '@carbon/icons-vue/lib/checkbox--checked/32'
import CheckboxCheckedFilled from '@carbon/icons-vue/lib/checkbox--checked--filled/32'
import Checkmark from '@carbon/icons-vue/lib/checkmark/32'
import CheckmarkOutline from '@carbon/icons-vue/lib/checkmark--outline/32'
import CheckmarkFilled from '@carbon/icons-vue/lib/checkmark--filled/32'
import ChevronUp from '@carbon/icons-vue/lib/chevron--up/32'
import ChevronDown from '@carbon/icons-vue/lib/chevron--down/32'
import ChevronLeft from '@carbon/icons-vue/lib/chevron--left/32'
import ChevronRight from '@carbon/icons-vue/lib/chevron--right/32'
import Close from '@carbon/icons-vue/lib/close/32'
import CloseOutline from '@carbon/icons-vue/lib/close--outline/32'
import CloudUpload from '@carbon/icons-vue/lib/cloud--upload/32'
import Delivery from '@carbon/icons-vue/lib/delivery/32'
import DeliveryAdd from '@carbon/icons-vue/lib/delivery--add/32'
import DeliveryTruck from '@carbon/icons-vue/lib/delivery-truck/32'
import Document from '@carbon/icons-vue/lib/document/32'
import DocumentDownload from '@carbon/icons-vue/lib/document--download/32'
import DocumentExport from '@carbon/icons-vue/lib/document--export/32'
import Download from '@carbon/icons-vue/lib/download/32'
import Edit from '@carbon/icons-vue/lib/edit/32'
import Email from '@carbon/icons-vue/lib/email/32'
import FilterIcon from '@carbon/icons-vue/lib/filter/32'
import ImageIcon from '@carbon/icons-vue/lib/image/32'
import Information from '@carbon/icons-vue/lib/information/32'
import Launch from '@carbon/icons-vue/lib/launch/32'
import List from '@carbon/icons-vue/lib/list/32'
import Receipt from '@carbon/icons-vue/lib/receipt/32'
import Locked from '@carbon/icons-vue/lib/locked/32'
import Notification from '@carbon/icons-vue/lib/notification/32'
import NotificationOff from '@carbon/icons-vue/lib/notification--off/32'
import Settings from '@carbon/icons-vue/lib/settings/32'
import ShoppingCartPlus from '@carbon/icons-vue/lib/shopping--cart--plus/32'
import TrashCan from '@carbon/icons-vue/lib/trash-can/32'
import User from '@carbon/icons-vue/lib/user/32'
import UserAvatar from '@carbon/icons-vue/lib/user--avatar/32'
import UserFollow from '@carbon/icons-vue/lib/user--follow/32'
import UserMultiple from '@carbon/icons-vue/lib/user--multiple/32'
import UserRole from '@carbon/icons-vue/lib/user--role/32'
import Phone from '@carbon/icons-vue/lib/phone/32'
import Globe from '@carbon/icons-vue/lib/globe/32'
import Warning from '@carbon/icons-vue/lib/warning/32'
import Copy from '@carbon/icons-vue/lib/copy/32'
import Printer from '@carbon/icons-vue/lib/printer/32'
import Pdf from '@carbon/icons-vue/lib/document--pdf/32'
import NotSent from '@carbon/icons-vue/lib/not-sent/32'
import ShoppingCartArrowDown from '@carbon/icons-vue/lib/shopping--cart--arrow-down/32'
import SettingsAdjust from '@carbon/icons-vue/lib/settings--adjust/32'
import Search from '@carbon/icons-vue/lib/search/32'
import Star from '@carbon/icons-vue/lib/star/32'
import StarFilled from '@carbon/icons-vue/lib/star--filled/32'
import Grid from '@carbon/icons-vue/lib/grid/32'
import ZoomIn from '@carbon/icons-vue/lib/zoom--in/32'
import ZoomOut from '@carbon/icons-vue/lib/zoom--out/32'
import DataShare from '@carbon/icons-vue/lib/data-share/32'
import Help from '@carbon/icons-vue/lib/help/32'
import Minimize from '@carbon/icons-vue/lib/minimize/32'
import Send from '@carbon/icons-vue/lib/send/32'
import SubtractAlt from '@carbon/icons-vue/lib/subtract--alt/32'
import Time from '@carbon/icons-vue/lib/time/32'

// CUSTOM ICONS
import Machine from '@/components/svg/machine'
import MachineInspect from '@/components/svg/machine-inspect'
import MachineSpareParts from '@/components/svg/machine-spare-parts'
import Noflight from '@/components/svg/noflight'
import ShoppingList from '@/components/svg/shopping-list'

Vue.use(CarbonIconsVue, {
  components: {
    Add,
    ArrowLeft,
    ArrowRight,
    Bookmark,
    Chat,
    Checkbox,
    CheckboxChecked,
    CheckboxCheckedFilled,
    Checkmark,
    CheckmarkOutline,
    CheckmarkFilled,
    ChevronUp,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Close,
    CloseOutline,
    CloudUpload,
    DataShare,
    Delivery,
    DeliveryAdd,
    DeliveryTruck,
    Document,
    DocumentDownload,
    DocumentExport,
    Download,
    Edit,
    Email,
    FilterIcon,
    ImageIcon,
    Information,
    Launch,
    List,
    Locked,
    Machine,
    MachineInspect,
    MachineSpareParts,
    Noflight,
    Notification,
    NotificationOff,
    NotSent,
    Settings,
    ShoppingCartPlus,
    TrashCan,
    User,
    UserAvatar,
    UserFollow,
    UserMultiple,
    UserRole,
    Receipt,
    Phone,
    Globe,
    Grid,
    Warning,
    Copy,
    Printer,
    Pdf,
    ShoppingCartArrowDown,
    ShoppingList,
    SettingsAdjust,
    Search,
    Star,
    StarFilled,
    Help,
    Minimize,
    Send,
    SubtractAlt,
    Time,
    ZoomIn,
    ZoomOut
  }
})
